const formatTime = (seconds) => {
  if (!seconds || seconds < 0) return '--';
  if (seconds < 60) return `${seconds.toFixed(0)}s`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ${Math.floor(seconds % 60)}s`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ${Math.floor((seconds % 3600) / 60)}m`;
  return `${Math.floor(seconds / 86400)}d ${Math.floor((seconds % 86400) / 3600)}h`;
};

const MeasurePopup = ({ data, liveData, containerWidth }) => {
  const d = liveData || data;
  if (!d) return null;

  const { pointA, pointB, priceDiff, percentChange, timeDiffSeconds } = d;
  const isLive = !!liveData;
  const isUp = priceDiff >= 0;

  // Compute position from chart coordinates if available
  const midX = data?.midX || 100;
  const midY = data?.midY || 100;
  const x = Math.min(Math.max(midX - 80, 4), (containerWidth || 800) - 168);

  return (
    <div
      style={{
        position: 'absolute',
        left: x,
        top: Math.max(midY - 50, 4),
        zIndex: 20,
        background: 'rgba(22, 26, 30, 0.95)',
        border: `1px solid ${isLive ? '#FF9800' : '#2b3139'}`,
        borderRadius: '6px',
        padding: '8px 12px',
        fontFamily: "'Segoe UI', sans-serif",
        fontSize: '11px',
        color: '#eaecef',
        pointerEvents: 'none',
        minWidth: '150px',
      }}
    >
      <div style={{
        borderBottom: '1px solid #2b3139', marginBottom: '6px',
        paddingBottom: '4px', color: isLive ? '#FF9800' : '#90949a',
        fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.5px',
        display: 'flex', justifyContent: 'space-between',
      }}>
        <span>Measurement</span>
        {isLive && <span style={{ fontSize: '9px', color: '#90949a' }}>LIVE</span>}
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px' }}>
        <span style={{ color: '#90949a' }}>Δ Price:</span>
        <span style={{ color: isUp ? '#0ecb81' : '#f6465d' }}>
          {isUp ? '+' : ''}${Math.abs(priceDiff).toFixed(2)}
        </span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', marginTop: '2px' }}>
        <span style={{ color: '#90949a' }}>Δ %:</span>
        <span style={{ color: isUp ? '#0ecb81' : '#f6465d' }}>
          {isUp ? '+' : ''}{percentChange.toFixed(2)}%
        </span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', marginTop: '4px', borderTop: '1px solid #2b3139', paddingTop: '4px' }}>
        <span style={{ color: '#90949a' }}>Time:</span>
        <span>{formatTime(timeDiffSeconds)}</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', marginTop: '2px' }}>
        <span style={{ color: '#90949a' }}>From:</span>
        <span>${pointA.price.toFixed(2)}</span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px' }}>
        <span style={{ color: '#90949a' }}>To:</span>
        <span>${pointB.price.toFixed(2)}</span>
      </div>
    </div>
  );
};

export default MeasurePopup;
